export { AggregationsLoader } from './aggregations-loader'
import { IntlShape, MessageDescriptor } from 'react-intl'

export interface Bucket {
  readonly count?: number
  readonly key: any
}

export type Aggregations<TCategories extends string> = Record<
  TCategories,
  Bucket[]
>

export type AggregationOptions<TCategories extends string> = Record<
  TCategories,
  string[]
>

export interface AggregationConfig {
  readonly groupName?: MessageDescriptor
  /** This parameter can be used as an alternative to providing a MessageDescriptor  */
  readonly groupDisplayName?: string
  readonly bucketToString?: (bucket: Bucket, intl: IntlShape) => string
  readonly bucketToID?: (bucket: Bucket) => string
  readonly bucketToTooltipContent?: (
    bucket: Bucket,
    intl: IntlShape
  ) => React.ReactNode
  readonly bucketToGroupIndex?: (bucket: Bucket) => number
}

export type AggregationConfigs<TCategories extends string> = Record<
  TCategories,
  AggregationConfig
>

export type AggregationBucketIDConfigs<TCategories extends string> = Record<
  TCategories,
  Pick<AggregationConfig, 'bucketToID'>
>

export const defaultBucketToID = ({ key }: Bucket) => key
